<template>
  <span>
        <ul ref="transRate" :class="['trans-rate', {['trans-rate' + '-disabled']: disabled}]" @mouseout="recovery">
            <li :key="index" :class="['trans-rate' + '-star' + iconFont,item.valueCls ? item.valueCls : '', item.hoverCls ? item.hoverCls : '']" v-for="(item, index) in lightArr" @mouseover="allLight(index)" @click="selected">
                <div :class="'trans-rate' + '-star' + iconFont+ '-content'" @mouseover="halfLight(index, $event)"></div>
            </li>
        </ul>
        <slot></slot>
    </span>
</template>
<script>
    export default {
      name: 'rate',
      data() {
        return {
          prefixCls: 'ant-rate',
          currentValue: this.valueHandle(this.value),
          hoverValue: 0
        }
      },
      props: {
        count: {
          type: Number,
          default: 5
        },
        iconFont: {
          type: String,
          default: ''
        },
        value: {
          type: Number,
          default: 0
        },
        disabled: {
          type: Boolean,
          default: false
        },
        allowHalf: {
          type: Boolean,
          default: false
        },
        size: {
          type: String,
          default: '20'
        }
      },
      computed: {
        lightArr() {
          const arr = []
          if (this.count) {
            for (let i = 0; i < this.count; i++) {
              arr.push({})
            }
          }
          /* 显示当前值 */
          let i = 0
          for (; i < parseInt(this.currentValue, 10); i++) {
            arr[i].valueCls = `trans-rate-star-full`
          }
          if (parseInt(this.currentValue, 10) !== this.currentValue) {
            arr[i].valueCls = `trans-rate-star-half`
          }
          /* 当用户hover时，高亮 */
          let j = 0
          for (; j < parseInt(this.hoverValue, 10); j++) {
            arr[j].hoverCls = `trans-rate-star-full`
          }
          if (parseInt(this.hoverValue, 10) !== this.hoverValue) {
            arr[j].hoverCls = `trans-rate-star-half`
          }
          return arr
        }
      },
      methods: {
        recovery() {
          this.hoverValue = 0
        },
        allLight(index) {
          if (this.disabled) return
          this.hoverValue = index + 1
        },
        halfLight(index, e) {
          if (this.disabled) return
          if (this.allowHalf) {
            this.hoverValue = index + 0.5
            e.stopPropagation()
          }
        },
        selected() {
          if (this.disabled) return
          this.currentValue = this.hoverValue
        },
        /* 根据allowHalf 对value进行不同的处理 */
        valueHandle(val) {
          /* 如果允许半选 整数直接返回  小数将小数部分变成.5 */
          if (val > this.count) {
            /* 强制转换 */
            this.$emit('change', this.count)
            this.$emit('input', this.count)
            // this.dispatch('FormItem', 'form.change', [this.count])
            return this.count
          }
          if (this.allowHalf) {
            const _v = parseInt(val, 10)
            if (_v !== val) {
              val = _v + 0.5
            }
            return val
          }
          /* 不允许半选直接四舍五入 */
          return Math.round(val)
        }
      },
      watch: {
        value(value) {
          this.currentValue = value
        },
        currentValue(value) {
          this.$emit('change', value)
          this.$emit('input', value)
          // this.dispatch('FormItem', 'form.change', [value])
        }
      },
      mounted () {
        // console.log(1)
        this.$refs.transRate.style.fontSize = this.size + 'px'
      }
    }
</script>
<style lang="scss">

.trans-rate {
  margin: 0;
  padding: 0;
  list-style: none;
  // font-size: 20px;
  display: inline-block;
  vertical-align: middle;
  font-family: 'FontAwesome';
  font-weight: normal;
  font-style: normal;

  &-disabled &-star {
    &:before,
    &-content:before {
      cursor: default;
    }
    &:hover {
      transform: scale(1);
    }
  }
  &-disabled &-star-o {
    &:before,
    &-content:before {
      cursor: default;
    }
    &:hover {
      transform: scale(1);
    }
  }
  &-disabled &-star-h {
    &:before,
    &-content:before {
      cursor: default;
    }
    &:hover {
      transform: scale(1);
    }
  }

  &-star {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-right: 8px;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }

    &:before,
    &-content:before {
      color: #e9e9e9;
      cursor: pointer;
      content: "\f005";
      transition: all 0.3s ease;
      display: block;
    }


    &-content {
      position: absolute;
      left: 0;
      top: 0;
      width: 50%;
      height: 100%;
      overflow: hidden;
      &:before {
        color: transparent;
      }
    }


    &-half &-content:before,
    &-full:before {
      color: #f5a623;
    }


    &-half:hover &-content:before,
    &-full:hover:before {
      color: tint(#f5a623, 20%);
    }

  }
  &-star-o {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-right: 8px;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }

    &:before,
    &-content:before {
      color: #e9e9e9;
      cursor: pointer;
      content: "\f006";
      transition: all 0.3s ease;
      display: block;
    }


    &-content {
      position: absolute;
      left: 0;
      top: 0;
      width: 50%;
      height: 100%;
      overflow: hidden;
      &:before {
        color: transparent;
      }
    }


    &.trans-rate-star-half &-content:before,
    &.trans-rate-star-full:before {
      color: #f5a623 !important;
    }


    &.trans-rate-star-half:hover &-content:before,
    &.trans-rate-star-full:hover:before {
      color: tint(#f5a623, 20%) !important;
    }

  }
  &-star-h {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-right: 8px;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }

    &:before,
    &-content:before {
      color: #e9e9e9;
      cursor: pointer;
      content: "\f004";
      transition: all 0.3s ease;
      display: block;
    }


    &-content {
      position: absolute;
      left: 0;
      top: 0;
      width: 50%;
      height: 100%;
      overflow: hidden;
      &:before {
        color: transparent;
      }
    }


    &.trans-rate-star-half &-content:before,
    &.trans-rate-star-full:before {
      color: #f5a623 !important;
    }


    &.trans-rate-star-half:hover &-content:before,
    &.trans-rate-star-full:hover:before {
      color: tint(#f5a623, 20%) !important;
    }

  }



  &-text {
    margin-left: 8px;
    vertical-align: middle;
    display: inline-block;
    font-size: 14px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components-base/components-custom/rate/rate.vue